const MultiCheckbox = ({ value = [], setValue, list, disabled, fix = [], disableRole = [] }) => {
  const handleChange = (checkedValue) => {
    if (value.includes(checkedValue)) {
      setValue(value.filter((v) => v !== checkedValue));
    } else {
      setValue([...value, checkedValue]);
    }
  };

  const isDisabled = (itemValue) => {
    return disabled || (fix.includes(itemValue) && disableRole.includes(itemValue));
  };

  return (
    <div className="flex items-start flex-col gap-2">
      {list.map((item) => (
        <label
          key={item.value}
          className="flex items-center gap-2 cursor-pointer"
        >
          <input
            type="checkbox"
            value={item.value}
            checked={value.includes(item.value)}
            onChange={() => handleChange(item.value)}
            disabled={isDisabled(item.value)}
            className="w-4 h-4 cursor-pointer"
          />
          <span className="text-[16px] font-['Prompt']">{item.name}</span>
        </label>
      ))}
    </div>
  );
};

export default MultiCheckbox;
